class CustomDrawer extends HTMLElement {
  constructor() {
    super();

    // Drawer container
    this.drawer = this;
    this.url = new URL(window.location.href);
    console.log(this.url);
    // Form titles
    this.signInTitle = this.querySelector("[data-sign-in-title]");
    this.signUpTitle = this.querySelector("[data-sign-up-title]");

    // Forms
    this.signInForm = this.querySelector("[data-login-form]");
    this.signUpForm = this.querySelector("[data-register-form]");
    this.recoverForm = this.querySelector("[data-recover-password-form]");

    // Buttons inside drawer
    this.createAccountBtn = this.querySelector("[data-create-account]");
    this.createAccountCon = this.querySelector("[data-create-account-con]");
    this.closeBtn = this.querySelector(".close-custom-drawer");
    this.recoverLink = this.querySelector("[data-recover-link]");
    this.hideRecoverLink = this.querySelector("[data-hideresetpass]");

    // Error messages
    this.loginError = this.querySelector("#customerLoginForm .errorMessageCustom-login");
    this.recoverError = this.querySelector("#customerLoginFormRecover .errorMessageCustom-recover");

     // hide show text
 
     this.hideShowBtn = this.querySelectorAll("#customerLoginForm .password-filed-btn");

    // External open buttons
    this.signInBtn = document.querySelector("#signin");
    this.signUpBtn = document.querySelector("#signup");
    this.signInBtnMobile = document.querySelector("#signin-mobile");
    this.signUpBtnMobile = document.querySelector("#signup-mobile");

    // Flags from query parameters
    const loginAttempted = this.url.searchParams.get("login_attempted");
    const loggedIn = this.url.searchParams.get("logged_in");
    const recovered = this.url.searchParams.get("recovered");

    // Handle failed login
    if (loginAttempted === "false") {
      localStorage.removeItem("customerLoginAttempt");
      this.url.searchParams.delete("login_attempted");
      window.history.replaceState({}, "", this.url.toString());

      this.openDrawer(true);
      this.showLoginError();
    } else {
      this.hideLoginError();
    }

    // Handle successful login
    if (loggedIn === "true") {
      this.url.searchParams.delete("logged_in");
      const redirectURL = localStorage.getItem("redirect_after_login") || "/pages/account";
      localStorage.removeItem("redirect_after_login");
      window.location.href = redirectURL;
      this.hideLoginError();
    }

    // Handle password recovery failure
    if (recovered === "false") {
      this.url.searchParams.delete("recovered");
      window.history.replaceState({}, "", this.url.toString());
     console.log("in if...")
     this.openDrawer(true);
      this.showRecoverError();
      this.showRecoverForm();
    }
    else{
      this.recoverError?.classList.add("d-none");
     
    }
    if(recovered === "true"){
      this.recoverError?.classList.remove("d-none");
      this.url.searchParams.delete("recovered");
      window.history.replaceState({}, "", this.url.toString());
      this.recoverError.innerHTML = "Password reset email has been sent to your email address.";
      this.openDrawer(true);
      this.showRecoverError();
      this.showRecoverForm();
    }
  }

  connectedCallback() {
    this.attachEvents();
  }

  getSearchString() {
    const params = this.url.searchParams.toString();
    return params ? `?${params}` : "";
  }

  showLoginError() {
    if (this.loginError) this.loginError.classList.remove("d-none");
  }

  hideLoginError() {
    if (this.loginError) this.loginError.classList.add("d-none");
  }

  showRecoverError() {
    if (this.recoverError) this.recoverError.classList.remove("d-none");
  }

  checkLoginAttempt(event, msg, mode = "signIn") {
    form.submit(); // Note: `form` is undefined unless passed or declared
  }

  attachEvents() {
    this.signInBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.openDrawer(true);
    });

    this.signInBtnMobile?.addEventListener("click", (e) => {
      e.preventDefault();
      this.openDrawer(true);
    });

    this.signUpBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.openDrawer(false);
    });

    this.signUpBtnMobile?.addEventListener("click", (e) => {
      e.preventDefault();
      this.openDrawer(false);
    });

    this.closeBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeDrawer();
    });

    this.createAccountBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.showSignUp();
    });

    this.recoverLink?.addEventListener("click", (e) => {
      e.preventDefault();
      this.showRecoverForm();
    });

    this.hideRecoverLink?.addEventListener("click", (e) => {
      e.preventDefault();
      this.showSignIn();
    });

    this.hideShowBtn?.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
    
        const type = btn.dataset.type;
        const passwordInput = this.querySelector("#customerPassword");
    
        if (!passwordInput) return;
    
        // Switch input type
        const isShowing = type === "show";
        passwordInput.type = isShowing ? "text" : "password";
    
        // Get both buttons
        const showBtn = this.querySelector('.password-filed-btn[data-type="show"]');
        const hideBtn = this.querySelector('.password-filed-btn[data-type="hide"]');
    
        // Toggle icon visibility
        if (isShowing) {
          showBtn.classList.add("d-none");
          hideBtn.classList.remove("d-none");
        } else {
          hideBtn.classList.add("d-none");
          showBtn.classList.remove("d-none");
        }
      });
    });
    
    
  }

  openDrawer(isSignIn = true) {
    this.drawer.classList.add("opened-drawer");
    this.createAccountCon.style.display = "block";
    isSignIn ? this.showSignIn() : this.showSignUp();
       setTimeout(() => {
    const form = isSignIn ? this.signInForm : this.signUpForm;
     console.log(form ,"form")
    const firstInput = form?.querySelector("input:not([type='hidden']):not([disabled])");
    firstInput?.focus();
    }, 100);
  }

  closeDrawer() {
    this.drawer.classList.remove("opened-drawer");
  }

  showSignIn() {
    this.toggleForms("signIn");
  }

  showSignUp() {
    this.toggleForms("signUp");
  }

  showRecoverForm() {
    console.log("recover")
    this.toggleForms("recover");
  }

  toggleForms(mode) {
    this.signInForm.style.display = mode === "signIn" ? "block" : "none";
    this.signUpForm.style.display = mode === "signUp" ? "block" : "none";
    this.recoverForm.style.display = mode === "recover" ? "block" : "none";

    this.signInTitle.style.display = mode === "signIn" ? "block" : "none";
    this.signUpTitle.style.display = mode === "signUp" ? "block" : "none";

    this.createAccountCon.style.display = mode === "signUp" || mode === "recover" ? "none" : "block";
  }
}

customElements.define("login-sign-up-drawer", CustomDrawer);
